import {Box} from "@mui/system";
import React, {useState} from "react";
import Timer from "../../../components/Timer";

import {
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  styled,
  Typography,
} from "@mui/material";
import * as examApi from "../../../api/educationApi/examApi";
import {useCreateMutation, useGetQuery} from "../../../hooks/useQueryHooks";
import * as Params from "../../../models/clientModels/interfaces/apiParams";
import {ResponseItem, ResponseList} from "../../../models/clientModels/interfaces/Response";
import {EDQuestion} from "../../../models/serverModels/education/EDQuestion";

import {useQueryClient} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import MWProgress from "../../../components/MWProgress";
import {EDExam} from "../../../models/serverModels/education/EDExam";
import {alertStateAtom} from "../../../Recoil/Atom/AlertAtom";
import {tokenSelector, userState} from "../../../Recoil/Atom/authState";

const GuideTextContainer = styled(Card)(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& h5": {
    marginBottom: "16px",
    color: theme.palette.error.dark,
    lineHeight: 1.5,
  },

  "& button": {
    marginTop: "32px",
  },
}));

const Item = styled(Paper)(({theme}) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
  minHeight: "200px",
  borderRadius: "16px",
  // border: `1px solid ${theme.palette.success.light}`,
}));

const NumberCheck = styled(FormControlLabel)<{number?: number}>(
  ({theme, number}) => `
  
.css-hyxlzm {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.css-hyxlzm:after {
  content: "${number}";
  position: absolute;
  display: block;
  font-size: 16px;
  font-weight: 700;
}
`
);
type SubmitType = {
  userUID: number;
  curriculumUID: number;
  answers: number[];
};

const TakeExam = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const setAlertState = useSetRecoilState(alertStateAtom);

  const tokenState = useRecoilValue(tokenSelector);
  const user = useRecoilValue(userState);

  const [answers, setAnswers] = useState<number[]>([]);

  const {data: examList, isLoading} = useGetQuery<ResponseList<EDQuestion>>({
    key: ["ExamQuestionList", {id, token: tokenState}],
    api: () => examApi.getList({id: parseInt(id!), token: tokenState}),
    options: {
      refetchOnWindowFocus: false,
      onSuccess: (examList: ResponseList<EDQuestion>) =>
        setAnswers(new Array(examList?.items.length).fill(0)),
    },
  });

  const {mutate: submitMutate} = useCreateMutation<ResponseItem<EDExam>, Params.Submit<SubmitType>>(
    {
      api: examApi.submit,

      options: {
        onSuccess: (data: ResponseItem<EDExam>) => {
          navigate("/Education/ExamResult", {
            state: {length: answers.length, correct: data.item?.correct, score: data.item?.score},
          });
          queryClient.invalidateQueries("MyEval");
        },
      },
    }
  );

  const changeAnswerHandler = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    setAnswers(answers.map((item, idx) => (idx === index ? parseInt(event.target.value) : item)));
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <MWProgress />
      ) : Array.isArray(examList?.items) && examList?.items.length === 0 ? (
        <GuideTextContainer>
          <Typography variant="h5">작성된 문항이 없습니다.</Typography>
          <Typography>관리자에게 문의하시기 바랍니다.</Typography>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={() => {
              navigate("/Education/MyEval");
            }}
            autoFocus={true}
          >
            평가목록으로 돌아가기
          </Button>
        </GuideTextContainer>
      ) : (
        <Box>
          <Box
            sx={{
              zIndex: 10,
              position: "sticky",
              top: "0px",
              display: "flex",
              justifyContent: {xs: "center", md: "flex-end"},
              marginBottom: "24px",
            }}
          >
            <Timer
              execution={() =>
                submitMutate({
                  id: parseInt(id!),
                  token: tokenState,
                  item: {
                    userUID: user.uid,
                    curriculumUID: parseInt(id!),
                    answers,
                  },
                })
              }
            />
          </Box>
          <Grid container spacing={4}>
            {examList?.items.map((item, index) => (
              <Grid key={item.uid} item xs={12} sm={6}>
                <Item>
                  <Typography sx={{fontWeight: 700, paddingBottom: "6px"}}>
                    <span>{index + 1}.</span>
                    {item.question}
                  </Typography>
                  <FormControl>
                    <RadioGroup onChange={(event) => changeAnswerHandler(event, index)}>
                      <NumberCheck
                        number={1}
                        id="1"
                        value={1}
                        label={item.answer1}
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 28,
                              },
                            }}
                          />
                        }
                      />

                      <NumberCheck
                        number={2}
                        value={2}
                        label={item.answer2}
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 28,
                              },
                            }}
                          />
                        }
                      />
                      <NumberCheck
                        number={3}
                        value={3}
                        label={item.answer3}
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 28,
                              },
                            }}
                          />
                        }
                      />
                      <NumberCheck
                        number={4}
                        value={4}
                        label={item.answer4}
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 28,
                              },
                            }}
                          />
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Item>
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              margin: "48px 0",
              width: "100%",
            }}
          >
            <Box sx={{width: {xs: "60%", md: "30%"}}}>
              <Button
                style={{width: "100%"}}
                variant="contained"
                color="success"
                size="large"
                disabled={answers.includes(0)}
                onClick={() => {
                  setAlertState({
                    toggle: true,
                    message: "답안을 제출하시겠습니까?",
                    execution: () =>
                      submitMutate({
                        id: parseInt(id!),
                        token: tokenState,
                        item: {
                          userUID: user.uid,
                          curriculumUID: parseInt(id!),
                          answers,
                        },
                      }),
                  });
                }}
              >
                제출
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </React.Fragment>
  );
};

export default TakeExam;
